import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IndustrySector, IndustrySectorModel } from 'app/shared/components/interfaces/GetAllIndustrySectors.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DomainsService {

  url:string=environment.domain;

  allIndustrySector:BehaviorSubject<IndustrySector[]>  =new BehaviorSubject([new IndustrySectorModel()]) 


  constructor(private http:HttpClient) { 
    this.GetIndustrySectors()
  }

  GetIndustrySectorById(id:number):Observable<IndustrySector>{
    return this.http.get<IndustrySector>(`${this.url}IndustrySector/GetIndustrySectorById/${id}`)
  }

  GetIndustrySectors(){
    this.GetAllIndustrySectors().subscribe((res: any) => this.allIndustrySector.next(res.data) )
  }

  GetAllIndustrySectors():Observable<IndustrySector[]>{
    return this.http.get<IndustrySector[]>(`${this.url}IndustrySector/GetAllIndustrySectors`)
  }

  postIndustrySector(data:any){
    return this.http.post(`${this.url}IndustrySector/CreateIndustrySector`,data)
  }

  updateIndustrySector(data:any){
    return this.http.put(`${this.url}IndustrySector/UpdateIndustrySector`,data)
  }

  deleteIndustrySector(id:number){
    return this.http.delete(`${this.url}IndustrySector/DeleteIndustrySector/${id}`)
  }
}
